// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 406 ? "da91da01" : chunkId) + "." + {"45":"e65b922993d7dbdc","406":"20f71dcc0338fede","595":"ad4e38bf6d8b82da"}[chunkId] + ".js";
};